<!--
2021-11-29 CHP 梳理IsAppCid控制GiftPop的逻辑
2021-12-09 CHP 梳理IsAppCid控制GiftPop的逻辑, 只是不弹窗
2022-03-06 CHP 增加Banner、在线人数，修改赢家跑马灯位置
2022-07-19 HHY 各游戏类页面增加锦标赛活动入口
2022-09-25 HHY 将玩过的游戏置顶
-->
<template>
  <div class="fixedWidth">
    <div class="gamePage" id="gamePage" ref="gamePage" @scroll="handleScroll">
      <div class="banner-list-wrapper" :class="$store.state.isAndroidBrowser ? 'banner-list-wrapper-android' : ''">
        <Swipe
          :auto="5000"
          v-if="startupPopupConfig.BannerList && startupPopupConfig.BannerList.length > 0"
        >
          <SwipeItem
            v-for="(item, i) in startupPopupConfig.BannerList"
            :key="'p' + i"
            v-if="checkBannerCondition(item.Condition)"
          >
            <div class="carousel-item">
              <img
                :alt="item.Name"
                :src="item.ImageSrc"
                class="banner-image"
                @click="bannerAction(item.Type, item.RedirectPath, item.RedirectParams, item.IframeControlProperty, item.ModalControlProperty)"
              >
            </div>
          </SwipeItem>
        </Swipe>
      </div>

      <div class="streamer" id="livePlayer" @click="dailyBonusCollect"
           :style="{backgroundImage:'url('+require('../../assets/images/home/streamer.webp')+')'}">
        <span class="dailyBonus">{{ $t('lang.common.DailyBonus') }}</span>
        <div class="countDownTimer">{{ $t('lang.common.moreIn') }} {{ formatCountdownMinutes(countdown) }}</div>
        <div class="redPoint" v-show="$store.state.BetRewardHot||$store.state.CashBackHot"/>
      </div>

      <div
        class="selectContainer"
        :class="{ fixed: gameTypeNavFixed, fixedAndroid: !$store.state.isAndroidBrowser }"
        id="selectContainer"
      >
        <link rel="prefetch" v-for="(item,index) in topList" :href="item.srcAct" :key="index">
        <link rel="prefetch" v-if="topList[0]" :href="topList[0].src">
        <div class="swiperBox" :style="swiper&&swiper.isBeginning?'padding:0 5vw':'padding:0 0 0 10vw'">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in topList" :key="index">
                <div class="img-box" @click="selectType(item.value)">
                  <div class="middle-box" v-show="showType === item.value">
                    <img :src="item.srcAct" alt=""/>
                  </div>
                  <div class="middle-box" v-show="showType !== item.value">
                    <img :src="item.src" alt=""/>
                  </div>
                  <div :class="showType === item.value?'bottom-line-act':'bottom-line'">
                    <div class="line" v-html="item.label.replace(' ','<br/>')"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" @click="prev" v-show="swiper && !swiper.isBeginning">
            <img :src="goPrev" alt="">
          </div>
          <div class="swiper-button-next" @click="next" v-show="swiper && !swiper.isEnd">
            <img :src="goNext" alt="">
          </div>
        </div>
      </div>
      <div class='gameContainer' :style="hasProviderTypes.includes(showType)?'padding-top:2.5vw':''">
        <div class="providerContainer" :style="hasProviderTypes.includes(showType)?'':'height:0;overflow:hidden'">
          <link rel="prefetch" v-for="(item,index) in providersList" :href="item.Images" :key="index">
          <div class="providerBox">
            <div class="provider-swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide"
                     v-for="(item,index) in providersList" :key="index">
                  <div class="img-box" :class="{act: provider.Name === item.Name}" @click="selectProvider(item)">
                    <img :src="item.Images" alt=""/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="provider-button-prev" @click="prev2" v-show="providerSwiper && !providerSwiper.isBeginning">
          <img :src="goPrev" alt="">
        </div>
        <div class="provider-button-next" @click="next2" v-show="providerSwiper && !providerSwiper.isEnd">
          <img :src="goNext" alt="">
        </div>
        <div class="gameFilter" v-if="hasProviderTypes.includes(showType)">
          <div class="searchRow">
            <img :src="searchIcon" alt="search">
            <input
              type="text"
              name="filteringGameText"
              v-model="filteringGameText"
              @focus="onSearchInputFocused"
              @blur="onSearchInputBlur"
              :placeholder="$t('lang.home.searchGamePlaceholder')"
            />
          </div>
        </div>
        <div ref="gameContent" class="gameContent">
          <div ref="scroll">
            <Loadmore
              :bottomPullText="''"
              :bottomDropText="''"
              :bottomLoadingText="''"
              :auto-fill="false"
              :bottom-method="() => {
              searchGames(true)
            }"
              :bottom-all-loaded="hasLoadAll"
              ref="loadmore">
              <!-- begin 游戏样式活动图 YTW 20231020 -->
              <div class="game"
                   v-for="(hb,index) in hotBanners"
                   v-if="showType===hb.PositionType"
                   :key="'hb'+index">
                <div class="red-circle" v-if="showRedCircle(hb.RedirectPath)"/>
                <div class="imgContainer">
                  <div class="game-image-wrapper"
                       :style="{backgroundImage:'url('+hb.ImageSrc+')'}"
                       @click="bannerAction(hb.Type, hb.RedirectPath, hb.RedirectParams, hb.IframeControlProperty, hb.ModalControlProperty)"
                  >
                  </div>
                </div>
                <p>{{ hb.Name }}</p>
              </div>
              <!-- end 游戏样式活动图 YTW 20231020-->
              <div class="game"
                   :class="{'last': tournamentsCount===2 && index%2===1}"
                   v-if="showType==='MostPopular'"
                   v-for="(item, index) in tournaments"
                   :key="index + 'm'"
              >
                <div class="imgContainer">
                  <div class="game-image-wrapper" :style="{backgroundImage:'url('+item.ActivityImage+')'}"
                       @click="GotoTournament('/GameCompetition3',item.ActivityCode,item.GameCategroy,item.ActivityImage,item.ActivityName,item.BannerImage)">
                  </div>
                </div>
                <p>{{ item.ActivityName }}</p>
              </div>
              <div class="game" v-if="categoryShouldBeShown === showType">
                <div class="imgContainer">
                  <div class="game-image-wrapper" :style="{backgroundImage:'url('+ activityImageShouldBeShown +')'}"
                       @click="GotoTournament('/GameCompetition3',activityCodeShouldBeShown,showType,activityImageShouldBeShown,activityNameShouldBeShown,bannerImageShouldBeShown)">
                  </div>
                </div>
                <p>{{ activityNameShouldBeShown }}</p>
              </div>
              <div class="game"
                   v-for="(item, index) in recentlys"
                   :key="index + 'r'"
                   v-if="(showType==='MostPopular') || (showType===item.Category1)"
              >
                <div class="imgContainer">
                  <div class="game-image-wrapper" :style="{backgroundImage:'url('+item.ThumbnailUrl+')'}"
                       @click="fetchGame(item)">
                  </div>
                </div>
                <p>{{ item.GameNameEn }}</p>
              </div>
              <div
                class="game"
                :class="{'last': (index%2===1 && showType!=='MostPopular' && categoryShouldBeShown !== showType) || (showType==='MostPopular' && (tournamentsCount === 1 && (index+1)%2===1 || (tournamentsCount ===2 || tournamentsCount === 0) && index%2===1)) || (categoryShouldBeShown === showType && (index+1)%2===1)}"
                v-for="(item, index) in gameFilterList"
                :key="index"
                @click="fetchGame(item)"
              >
                <div class="imgContainer">
                  <div class="game-image-back" v-bind:style="{backgroundImage:'url(' + logo5 + ')'}">
                  </div>
                  <div class="game-image-wrapper" v-bind:style="{backgroundImage:'url('+item.ThumbnailUrl+')'}">
                  </div>
                  <div class="imgMask"/>
                </div>
                <img :src="newImg" v-if="item.IsNew" class="new-game" alt=""/>
                <p>{{ item.GameNameEn }}</p>
              </div>
            </Loadmore>
          </div>
          <div class="emptyGames" v-if="gameList.filter(game => isGameInFiltered(game)).length === 0">
            <span v-if="isOnSearch">{{ $t('lang.home.loading') }}</span>
            <span v-else>{{ $t('lang.home.noGameMatchFilter') }}</span>
          </div>
        </div>
      </div>
      <div id="limitTimer" class="gift-icon-timeLimit" v-if="showLimitTimeIcon&&lazyEnd">
        <div class="limit-bk"
             :style="{backgroundImage:'url('+require('../../assets/images/common/timeLimitIcon.gif')+')'}"
             @click="onShowLimitTimePop">
          <div class="limit-timer">{{ timeLeftString }}</div>
        </div>
      </div>
      <div class="right-bar">
        <div v-if="lazyEnd" class="ipl" @click="goto('SportsBetting')">
          <img :src="ipl" alt="">
          <div class="iplNum">17.7 Lakh</div>
        </div>
        <div v-if="cashWheelIsStart && lazyEnd" class="cashWheelIndexIcon" @click="goto('cashWheel')">
          <img :src="cashWheelIndexIcon" alt="">
          <div v-show="cashWheelRedDot" class="redPoint"/>
        </div>
        <div v-show="doubleDayShow.Switch&&lazyEnd" class="doubleDay" @click="goto('Holi')">
          <img :src="doubleDayWindowIcon" alt="">
<!--          <span class="rewardNum">₹{{doubleDayShow.BigReward}}</span>-->
        </div>
        <div v-show="DiwaliRankShow&&lazyEnd" class="diwaliFestival" @click="goto('DiwaliFestival')">
          <img :src="diwaliFestivalIcon" alt="">
          <div v-show="DiwaliRankRedDot" class="red-circle redPoint"/>
        </div>
        <div class="sharingStar" v-show="$store.state.sharingStarIcon&&lazyEnd" @click="goto('SharingStar')">
          <img :src="sharingStarIcon" alt="sharingStarIcon">
        </div>
        <div class="depositWin" v-show="$store.state.depositActivityIcon&&lazyEnd" @click="goto('DepositAndWin')">
          <img :src="depositWin" alt="deposit&win">
        </div>
        <div class="shareFiesta" v-show="$store.state.shareFiestaShow&&lazyEnd" @click="goto('ShareFiesta')">
          <img :src="shareFiesta" alt="shareFiesta">
          <div class="red-circle red-circle-shareFiesta" v-show="shareFiestaPointShow"/>
        </div>
        <div class="holi" v-if="holiShow&&lazyEnd" @click="goto('Holi')">
          <img :src="holi" alt="holi">
        </div>
        <div class="gift-icon-wrapper" @click="onShowGiftPop"
             v-if="$store.state.showGiftIcon&&lazyEnd">
          <div>
            <div class="red-circle red-circle-position" v-if="$store.state.giftShowRedCircle"></div>
            <img :src="dailyCorn" class="gift-icon" alt=""/>
          </div>
        </div>
        <div class="self-made-games-menu" :style="`background-image:url(${selfMadeGamesBg});`"
             v-if="lazyEnd"
             @click="onShowSelfMadeGamesSubMenu"
        >
        </div>
        <div class="self-made-game-icons" v-show="this.showSelfMadeGamesSubMenu">
          <img
            class="luckyWheelMenu_wheel"
            alt="luckyWheelMenu_wheel"
            :src="iconLuckywheel"
            v-for="(item, index) in wheelList" :key="index"
            @click="onShowLuckyWheelGamePop(item)"
            v-if="showSelfMadeGamesSubMenu"
          >
          <img
            class="luckyWheelMenu_card"
            alt="luckyWheelMenu_card"
            :src="iconLuckycard"
            @click="onShowLuckyCardGamePop"
            v-if="showSelfMadeGamesSubMenu"
          >
        </div>
        <!-- First Deposit -->
        <div class="bonus-icon-wrapper"
             v-if="$store.state.showDepositBonusIcon&&lazyEnd"
             @click="onShowBonusPop">
          <img :src="giftIcon" class="bonus-icon"/>
          <div class="countdown">{{ countdown }}</div>
        </div>
        <!-- Cash Callback -->
        <div
          class="bonus-icon-wrapper"
          v-if="($store.state.callbackTimeSpan > (new Date()).getTime())&&lazyEnd"
          @click="onShowCallbackPop"
        >
          <img :src="callbackPng" :width="54" class="bonus-icon" alt=""/>
        </div>
        <!--        <SocialShareGroup v-if="isNotAndroidApp&&lazyEnd"></SocialShareGroup>-->
      </div>
      <div class="user-guide-home" v-show="showHomeGuide" ref="homeGuide">
        <div class="guide-region">
          <div class="selectItem">
            <div class="labelAct">{{ $t('lang.label.hot') }}</div>
          </div>
          <div class="selectItem">
          </div>
          <div class="selectItem">
          </div>
          <div class="selectItem">
          </div>
          <div class="selectItem">
          </div>

          <div class="guide-region-border"></div>
        </div>
        <div class="prompt-region">
          <div class="logo">
            <img :src="logo" class="logo"/>
          </div>
          <div class="prompt-box">
            <span>{{ $t('lang.userGuide.homePrompt') }}</span>
          </div>
        </div>
        <div class="next-button-wrapper" @click="nextToDeposit">
          <span class="next-button">{{ $t('lang.common.next') }}</span>
        </div>
      </div>
      <div class="user-guide-deposit" v-show="showDepositGuide" ref="depositGuide">
        <div class="guide-region-border"></div>
        <div class="guide-region">
          <div class="guideItem"></div>
          <div class="guideItem"></div>
          <div class="guideItem">
            <img :src="depositIcon" alt="">
            <div class="label" :class="'labelAct'">{{ $t('lang.menu.Deposit') }}</div>
          </div>
          <div class="guideItem"></div>
        </div>
        <div class="prompt-region">
          <div class="logo">
            <img :src="logo" class="logo"/>
          </div>
          <div class="prompt-box">
            <span>{{ $t('lang.userGuide.depositPrompt') }}</span>
          </div>
          <div class="next-button-wrapper" @click="nextToWithdraw">
            <span class="next-button">{{ $t('lang.common.next') }}</span>
          </div>
        </div>
      </div>
      <div class="user-guide-withdraw" v-show="showWithdrawGuide" ref="withdrawGuide">
        <div class="guide-region-border"></div>
        <div class="guide-region">
          <div class="guideItem"></div>
          <div class="guideItem"></div>
          <div class="guideItem"></div>
          <div class="guideItem">
            <img :src="withdrawIcon" alt="">
            <div class="label" :class="'labelAct'">{{ $t('lang.menu.Withdraw') }}</div>
          </div>
        </div>
        <div class="prompt-region">
          <div class="logo">
            <img :src="logo" class="logo"/>
          </div>
          <div class="prompt-box">
            <span>{{ $t('lang.userGuide.withdrawPrompt') }}</span>
          </div>
          <div class="next-button-wrapper" @click="nextToSupport">
            <span class="next-button">{{ $t('lang.common.next') }}</span>
          </div>
        </div>
      </div>
      <div class="user-guide-support" v-show="showSupportGuide" ref="supportGuide">
        <div class="guide-region"
             v-bind:style="{top:supportTop + 'px'}"
             v-show="supportTop > 0">
          <div class="menuItem">
            <img :src="support" alt="">
            <div>{{ $t('lang.menu.Support') }}</div>
          </div>
        </div>
        <div class="prompt-region">
          <div class="logo">
            <img :src="logo" class="logo"/>
          </div>
          <div class="prompt-box">
            <span>{{ $t('lang.userGuide.supportPrompt') }}</span>
          </div>
          <div class="next-button-wrapper" @click="nextToGiftGuide">
            <span class="next-button">{{ $t('lang.common.next') }}</span>
          </div>
        </div>
      </div>
      <ConfirmWin v-if="this.$store.state.confirmWinShow" :hintText="balanceNotEnoughHint"
                  :confirmToDo="confirmGotoPage"></ConfirmWin>
      <DownloadAndroidAppModal
        v-if="isDownloadAndroidModalShowing"
        :handleClose="closeDownloadAndroidAppModal">
      </DownloadAndroidAppModal>
    </div>
    <FirstDepositGiftPop v-if="userInfo" v-show="verifyIfPopupFirstDeposit" :handleClose="closeDepositPop"
                         :countdown="countdown"></FirstDepositGiftPop>
    <Wheel v-if="showLuckyWheelGamePop" :handleClose="closeLuckyWheelGamePop" :theOwnWheel="theOwnWheel"></Wheel>
    <wheelDiscount :discountList="discountList" :closeDiscount="closeDiscount" bkType="1" :userInfo="userInfo"
                   v-show="showDiscount"></wheelDiscount>
    <TimeLimitDeposit v-if="userInfo" v-show="showLimitTimePop||calcLimitTimePop" :timeLimitRate="timeLimitRate"
                      :timeLimitMaxAmount="timeLimitMaxAmount" :timeLeftString="timeLeftString"
                      :closeTimeLimitDeposit="closeTimeLimitDeposit"></TimeLimitDeposit>
    <IFrame3Part
      :iFrameSrc="iFrameSrc"
      :handelClose="() => handleCloseIFrame3Part('showTournament')"
      v-if="showTournament"
    >
    </IFrame3Part>
  </div>
</template>

<script>
import {Loadmore, Toast, Swipe, SwipeItem} from 'mint-ui'
import request from '@/service'
import request2 from '@/service2'
import goPrev from '@/assets/images/home/goPrev.svg'
import goNext from '@/assets/images/home/goNext.svg'
import Swiper from 'swiper'
import IFrame3Part from '@/components/IFrame3Part/index'
import logo from '@/assets/images/common/logo4.svg'
import logo5 from '@/assets/images/common/logo5.png'
import hot from '@/assets/images/common/hot.svg'
import {fetchCurrency} from '@/constant'
import homeGuideImage from '@/assets/images/userGuide/homeguide.png'
import depositGuideImage from '@/assets/images/userGuide/depositguide.png'
import withdrawGuideImage from '@/assets/images/userGuide/withdrawguide.png'
import searchIcon from '@/assets/images/common/search.svg'
import support from '@/assets/images/Menu/support.svg'
import giftIcon from '@/assets/images/common/depositBonus.webp'
import withdrawIcon from '@/assets/images/footerGuide/withdrawAct.svg'
import depositIcon from '@/assets/images/footerGuide/depositAct.svg'
import FirstDepositGiftPop from '@/components/DepositGift/index'
import Wheel from '@/components/Wheel/index'
import DownloadAndroidAppModal from '@/components/DownloadAndroidAppModal/index'
import SocialShareGroup from '@/components/SocialShareGroup/index'
import callbackPng from '@/assets/images/common/returnBonus.png'
import bonusText from '@/assets/images/common/bonusText.svg'
import dailyCorn from '@/assets/images/common/DailyCash.webp'
import dailyText from '@/assets/images/common/DailyText.svg'
import cashText from '@/assets/images/common/CashText.svg'
import returnFreeCashTxt from '@/assets/images/callback/returnFreeCashTxt.svg'
import newImg from '@/assets/images/gameHotNew/gameNew.svg'
import laba from '@/assets/images/common/laba.png'
import iconLuckywheel from '@/assets/images/common/icon_luckywheel.svg'
import wheelDiscount from '@/components/Wheel/discount'
import iconLuckycard from '@/assets/images/common/iconLuckycard.svg'
import shareFiesta from '@/assets/images/common/shareFiesta1.png'
import depositWin from '@/assets/images/beginnersOnly/deposit&win.png'
import sharingStarIcon from '@/assets/images/SharingStar/sharingStarIcon.png'
import holi from '@/assets/images/common/holi.svg'
import ipl from '@/assets/images/sportsBetting/ipl.webp'
import diwaliFestivalIcon from '../../assets/images/DiwaliFestival/dawali.png'
import doubleDayWindowIcon from '../../assets/images/diwali/holi.svg'
import cashWheelIndexIcon from '../../assets/images/common/cashWheelIndexIcon.png'
import {
  getTimeSpanString,
  separateThousandInteger,
  separateThousand,
  checkBannerCondition,
  setCurrentModal,
  isIOS,
  clickEvent,
  LogUtils,
  fbListener
} from '@/utils'
import store from '@/store/store'
import config from '../../../static/config/config'
import ConfirmWin from '@/components/ConfirmWin/confirmWithOneButton'
import selfMadeGamesBg from '@/assets/images/selfMadeGame/entrance.png'
import TimeLimitDeposit from '../../components/TimeLimitDeposit/index'
import {mapMutations} from 'vuex'

export default {
  name: 'Games',
  data () {
    return {
      DiwaliRankShow: null,
      doubleDayShow: {
        Switch: false
      },
      visitorCode: localStorage.getItem('visitorCode'),
      DiwaliRankRedDot: null,
      cashWheelRedDot: null,
      goPrev,
      goNext,
      Swipe,
      SwipeItem,
      ipl,
      holi,
      searchIcon,
      depositWin,
      sharingStarIcon,
      cashWheelIndexIcon,
      shareFiesta,
      iconLuckywheel,
      iconLuckycard,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      topList: [],
      swiper: null,
      providerSwiper: null,
      providerIndex: 0,
      levelIndex: 0,
      showType: '',
      provider: '',
      allGames: {},
      hotBanners: [],
      hasProviderTypes: [],
      providersList: [],
      isOnSearch: true,
      gameList: [],
      gameFilterList: [],
      takeNum: 15,
      skipNum: 0,
      totalNum: 0,
      hasLoadAll: true,
      bannerInterval: null,
      fetchCurrency,
      showHomeGuide: false,
      showDepositGuide: false,
      showWithdrawGuide: false,
      showSupportGuide: false,
      showLimitTimeIcon: false,
      limitTimer: null,
      showLimitTimePop: false,
      timeLimitRate: '',
      timeLimitMaxAmount: '',
      theOwnWheel: 0,
      showLuckyWheelGamePop: false,
      showLuckyCardGamePop: false,
      showLotteryPop: false,
      iFrameSrc: '',
      showSelfMadeGamesSubMenu: false,
      showTournament: false,
      discountList: [],
      wheelList: [],
      homeGuideImage,
      diwaliFestivalIcon,
      doubleDayWindowIcon,
      logo,
      logo5,
      firstLoad: true,
      hot,
      depositGuideImage,
      withdrawGuideImage,
      support,
      supportTop: 0,
      giftIcon,
      withdrawIcon,
      depositIcon,
      FirstDepositGiftPop, // 2022-10-29 HHY 由DepositGiftPop改为了FirstDepositGiftPop
      showFirstDepositPop: false, // 2022-10-29 HHY 由show24HRBonus改为showFirstDepositPop,用来让Home页右下角晃动的gift图表控制首充弹出
      bonusText,
      dailyCorn,
      dailyText,
      cashText,
      timeLeftString: '00:00:00',
      getTimeSpanString,
      playGame: false,
      startupPopupConfig: {},
      allLocaleBanners: {},
      livePlayersCount: 0,
      separateThousandInteger,
      separateThousand,
      winnerList: [],
      winnerTimeout: null,
      winnerInterval: null,
      gameTypeNavFixed: false,
      laba,
      callbackPng: callbackPng,
      checkBannerCondition,
      newImg,
      // bubbleInfo: 'You still have Bonus unclaimed!',
      returnFreeCashTxt,
      navOriginTop: 0,
      tournaments: [],
      tournamentShown: {},
      tournamentsCount: 0,
      selectedCategory: {},
      categoryShouldBeShown: '',
      activityCodeShouldBeShown: '',
      activityImageShouldBeShown: '',
      activityNameShouldBeShown: '',
      bannerImageShouldBeShown: '',
      filteringGameText: '',
      waitingGamesInterval: null,
      recentlys: [],
      selfMadeGamePopupDate: '',
      selfMadeGameAlreadyPopupTimes: null,
      balanceNotEnoughHint: this.$t('lang.home.creditNotEnough'),
      selfMadeGamesBg,
      lazyEnd: false,
      isDownloadAndroidModalShowing: false,
      holiShow: false,
      shareFiestaPointShow: false,
      normalFlowRewardWaitClaim: false,
      cashbackWaitClaim: false,
      countdown: '',
      dailyBonusRedPointShow: false,
      cashWheelIsStart: false
    }
  },
  components: {
    TimeLimitDeposit,
    Loadmore,
    Swipe,
    SwipeItem,
    Swiper,
    IFrame3Part,
    FirstDepositGiftPop,
    wheelDiscount,
    Wheel,
    ConfirmWin,
    DownloadAndroidAppModal,
    SocialShareGroup
  },
  computed: {
    verifyIfPopup7DayGift: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 0) {
          return modals[0].showing
        } else {
          return false
        }
      }
    },
    comeFromTournament: {
      cache: false,
      get: function () {
        return sessionStorage.getItem('comeFromTournament')
      }
    },
    selectedActivity: {
      cache: false,
      get () {
        return sessionStorage.getItem('selectedActivity') === undefined ? undefined : JSON.parse(sessionStorage.getItem('selectedActivity'))
      }
    },
    verifyIfPopupFirstDeposit: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 1) {
          return modals[1].showing
        } else {
          return false
        }
      }
    },
    showDiscount: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 6) {
          return modals[6].showing
        } else {
          return false
        }
      }
    },
    calculateWheelShow: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 7) {
          return modals[7].showing
        } else {
          return false
        }
      }
    },
    calcLimitTimePop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 8) {
          return modals[8].showing
        } else {
          return false
        }
      }
    },
    isNotAndroidApp () {
      return typeof window.Android === 'undefined'
    }
  },
  watch: {
    '$route': function (to, from) {
      if (from.name === 'cashWheel') {
        this.gameTypeNavFixed = false
        this.getCashWeelReddot()
      }
    },
    'gameList': function () {
      this.judgeGameFilter()
    },
    'filteringGameText': function (n) {
      this.judgeGameFilter()
    },
    // 2022-03-27 CHP 监控语言切换更新导航文字
    '$store.state.locale': function () {
      this.loadIcons()
      this.loadStartupPopup()
    },
    showDiscount: function (n, o) {
      if (n) {
        this.fetchDiscount()
      }
    },
    calcLimitTimePop: function (n, o) {
      if (n) {
        this.fetchTimeLimitedBenefit()
      }
    },
    calculateWheelShow: function (n, o) { // 2023-07-25 YTW发现转盘需要弹出先验证转盘id
      if (n) {
        if (!this.wheelList || this.wheelList.length === 0) {
          let data = {}
          if (this.userInfo) {
            data = {UserId: this.userInfo.UserId}
          }
          request('post', '/innovation/luckywheel/get_wheel', data, false).then(res => {
            this.wheelList = res
            this.onShowLuckyWheelGamePop(this.wheelList[0])
          })
        } else {
          this.onShowLuckyWheelGamePop(this.wheelList[0])
        }
      }
    }
  },
  activated () { // 2022-08-04 HHY 增加，用于监听数据变化
    var len = Object.keys(this.allGames).length
    if (len > 0) {
      this.SelectSpecificType()
    } else { // 如果游戏列表还没加载，则等待
      this.waitingGamesInterval = setInterval(() => {
        len = Object.keys(this.allGames).length
        if (len > 0) {
          this.getTournaments()
        }
      }, 100)
    }
  },
  created () {
    // 每秒更新倒计时
    setInterval(this.updateCountdown, 1000)
    this.updateCountdown()
  },
  mounted () {
    fbListener('PageViewHome')
    this.callWheel()
    this.fetchLocalAmount()
    this.initActivity()
    this.fetchTimeLimitedBenefit()
    this.fetchActivityNormalReward()
    this.getIcon_reddot()
    this.getViralityEnter()
    this.getCashWeelReddot()
    this.getDoubleDaySetting()
    localStorage.setItem('popList', [])
    const initCategory = this.$route.query.category
    let data = {
      userId: this.userInfo ? this.userInfo.userId : null,
      internation: this.$store.state.internation,
      campaignId: localStorage.getItem('cid')
    }
    request('post', '/innovation/internal/allgames', data, false).then(res => {
      this.allGames = res
      if (initCategory) {
        let stateObject = {}
        let title = ''
        let newUrl = this.$route.path
        history.pushState(stateObject, title, newUrl)
        this.selectType(initCategory)
      }
      if (this.comeFromTournament === undefined || this.comeFromTournament === null || this.comeFromTournament === '0') {
        this.getTournaments() // 2022-07-19 HHY 增加
        // this.getRecently() // 2022-08-13 AGQ 增加
      }
      this.getCashbackWaitingClaim()
    }).catch(() => {
      document.getElementById('loading').style.display = 'none'
    })

    this.setCallbackBonusTimer()
    this.setCallbackCashTimer()
    this.navOriginTop = document.querySelector('#selectContainer').offsetTop

    this.selfMadeGamePopupDate = localStorage.getItem('selfMadeGamePopupDate') || new Date().toDateString()
    this.selfMadeGameAlreadyPopupTimes = JSON.parse(localStorage.getItem('selfMadeGameAlreadyPopupTimes')) || 0
    // icon再弹窗结束后加载
    this.lazyEnd = false
    setTimeout(() => {
      this.lazyEnd = true
    }, 2100)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.isLogin = !!localStorage.getItem('userInfo')
      vm.showMenu = false
      // 2021/11/19 WXJ 不是app渠道的直接进7天送礼界面
      if (localStorage.getItem('isAppCid') === 'true') {
        // vm.showHomeGuide = !localStorage.getItem('finishUserGuide')  // 2022-10-23 HHY 从代码逻辑看，User Guide的系列步骤任何情况下都已不显示，包括首充弹出
      } else {
        // vm.showGiftPop = true
      }

      if (from.name === 'PromotionRule') { // 2022-10-21 HHY 如果来自promotion页的首输返利活动
        // vm.showType = 'SlotGames' // 指向的游戏分类
        if (from.query.key === 'firstLose') {
          vm.$route.query.category = 'SlotGames'
        }
        if (from.query.key === 'sportsFirstLose') { // 2022-11-07 HHY 如果来自promotion页的（世界杯）首输返利活动
          vm.$route.query.category = 'SportsGames'
        }
        if (from.query.key === 'betRaffleWorldCup') { // 2022-11-25 HHY
          vm.$route.query.category = 'SportsGames'
        }
      }

      if (vm.$route.query.page === 'startUpPop') { // 2022-11-07 HHY 来自强弹图
        if (vm.$route.query.key === 'firstLose') { // 若是首输：指向SlotsGames
          vm.$route.query.category = 'SlotGames'
        }
        if (vm.$route.query.key === 'sportsFirstLose') { // 若是首输：指向SportsGames
          vm.$route.query.category = 'SportsGames'
        }
      }
    })
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute'
    }),
    getIcon_reddot () {
      request('post', 'innovation/home/get/icon_reddot', {userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).UserId : null}).then(res => {
        if (res) {
          this.DiwaliRankRedDot = res.DiwaliRankRedDot
          this.DiwaliRankShow = res.DiwaliRankShow
        }
      })
    },
    getViralityEnter () {
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null,
        visitorCode: this.visitorCode
      }
      request('post', 'innovation/virality/status', data, false).then(res => {
        this.cashWheelIsStart = res
      })
    },
    // 埋点
    saveUserEvent (from) { // 埋点
      const url = '/innovation/account/save/user/event'
      const data = {
        EventNameEN: 'VIR' + from,
        UserUniqueId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null
      }
      request('post', url, data, true).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    dailyBonusCollect () {
      if (!this.userInfo) {
        this.goto('Login')
      } else if (this.$store.state.BetRewardHot === true) {
        this.goto('BetActivityRegularly')
      } else if (this.$store.state.CashBackHot === true) {
        this.goto('CashBack')
      } else {
        this.goto('BetActivityRegularly')
      }
    },
    formatCountdownMinutes (countDown) {
      return countDown.substring(0, 5)
    },
    updateCountdown () {
      // 获取当前时间和目标时间的时间戳
      const now = new Date()
      const target = new Date(now)
      target.setHours(24, 0, 0, 0) // 设置目标时间为今天的 24 点
      const timeDifference = target.getTime() - now.getTime()

      // 计算时分秒
      const hours = Math.floor(timeDifference / (1000 * 60 * 60))
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000)

      // 格式化输出
      this.countdown = this.formatTime(hours) + ':' + this.formatTime(minutes) + ':' + this.formatTime(seconds)
    },
    formatTime (time) {
      return time < 10 ? '0' + time : time
    },
    getDoubleDaySetting () {
      request('post', 'innovation/dival/setting', {userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).UserId : null}).then(res => {
        if (res) {
          this.doubleDayShow = res
        }
      })
    },
    closeDownloadAndroidAppModal: function () {
      this.isDownloadAndroidModalShowing = false
    },
    handleScroll: function () {
      if (document.querySelector('#gamePage') &&
        document.querySelector('#selectContainer')) {
        let scrollTop = document.querySelector('#gamePage').scrollTop + 10
        let scrollHeight = document.querySelector('#gamePage').scrollHeight
        let clientHeight = document.querySelector('#gamePage').clientHeight
        let offsetTop = document.querySelector('#livePlayer').offsetTop + document.querySelector('#livePlayer').clientHeight
        let isBottom = scrollTop + clientHeight >= scrollHeight - 1
        if (this.$store.state.isAndroidBrowser) {
          scrollTop = scrollTop + window.innerWidth * 0.15
        }
        if (scrollTop > offsetTop || (scrollTop > 0 && isBottom && this.gameList && this.gameList.length > 6)) {
          this.gameTypeNavFixed = true
        } else {
          this.gameTypeNavFixed = false
        }
      }
    },
    onShowLimitTimePop () {
      this.showLimitTimePop = true
    },
    selectType (type) {
      this.gameTypeNavFixed = false
      this.hasProviderTypes = []
      this.getTournament(type)
      if (document.getElementById('loading').innerHTML.trim() === '') {
        var imageHtml = '<div><img src="static/images/loading.gif" alt=""></div>'
        document.getElementById('loading').innerHTML = imageHtml
      }
      document.getElementById('loading').style.display = 'block'
      this.$refs.gamePage.scrollTop = 0
      this.showType = type
      // 点击类型该类型居中
      if (this.swiper) {
        const current = this.topList.findIndex(item => item.value === this.showType)
        if (current > 1) {
          this.swiper.slideTo(current - 2)
        } else {
          this.swiper.slideTo(0)
        }
      }
      const games = this.allGames.filter((e) => {
        return e.Name === type
      })[0]
      if (games && games.ProviderItems && games.ProviderItems.length > 0) {
        let that = this
        this.totalNum = 0
        this.hasProviderTypes.push(type)
        games.ProviderItems.forEach((e) => { // 有游戏上的分类
          if (e.games && e.games.length > 0) {
            that.totalNum += e.games.length
          }
        })
        this.provider = games.ProviderItems[0]
        this.providersList = games.ProviderItems
      } else {
        this.totalNum = games.Games.length
      }
      setTimeout(() => {
        this.initProviderSwiper()
        this.providerIndex = 0
        this.providerSwiper.slideTo(0)
      }, 0)
      this.filteringGameText = ''
      this.searchGames()
      document.getElementById('loading').style.display = 'none'
    },
    selectProvider (key) {
      this.gameTypeNavFixed = false
      this.$refs.gamePage.scrollTop = 0
      this.provider = key
      let games = this.allGames.filter((item) => {
        return item.Name === this.showType
      })[0]
      this.totalNum = games.ProviderItems.filter((provider) => {
        return provider.Name === key.Name
      }).length
      // 点击游戏商该游戏商居中
      if (this.providerSwiper) {
        const current = this.providersList.findIndex(item => item.Name === this.provider.Name)
        if (current > 1) {
          this.providerSwiper.slideTo(current - 2)
        } else {
          this.providerSwiper.slideTo(0)
        }
      }
      this.searchGames()
    },
    searchGames (loadMore) {
      if (!loadMore) {
        this.skipNum = 0
        this.gameList = []
        this.firstLoad = true
        this.hasLoadAll = true
      }
      this.hotBanners = this.allGames.filter((item) => {
        return item.Name === this.showType
      })[0].HotBanner
      const game = this.allGames.filter((item) => {
        return item.Name === this.showType
      })[0]
      if (this.hasProviderTypes.includes(this.showType)) {
        this.gameList = game.ProviderItems.filter((item) => {
          return item.Name === this.provider.Name
        })[0].Games
      } else {
        this.gameList = game.Games
      }
      this.mergeHistoryGames() // 将玩过的游戏置顶 2022-09-24 HHY
      this.skipNum += this.takeNum
      this.hasLoadAll = true // this.gameList.length >= this.totalNum
      if (!this.firstLoad) {
        this.$refs.loadmore.onBottomLoaded()
      }
      this.firstLoad = false
    },
    clickWinner (game) {
      clickEvent({EventNameEN: 'clickWinner'})
      this.fetchGame(game)
    },
    recordGameClicked (game) {
      if (game.GameCode === 'SabaSports' || game.GameCode === '9wicket-01a25') {
        clickEvent({EventNameEN: game.GameCode})
      }
    },
    fetchGame (game) { // 原来的fetchGame
      if (this.userInfo) {
        if (this.$store.state.banUserId.includes(this.userInfo.UserId)) {
          Toast(this.$t('lang.home.gameMaintenancePrompt'))
          return
        }
        this.recordPlayedGame(game) // 记录用户玩过的游戏
        this.recordGameClicked(game)
        const url = '/innovation/game/getgameurl'
        const data = {
          userId: this.userInfo.UserId || '',
          gameCode: game.GameCode,
          gameProviderId: game.GameProviderId,
          deviceWidth: document.body.clientWidth,
          lang: localStorage.getItem('locale'),
          internation: this.$store.state.internation,
          campaignId: localStorage.getItem('cid'),
          localVersion: config.version,
          localApkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0'
        }
        request('post', url, data).then(res => {
          if (res.Url) {
            const gameInfo = {
              gameUrl: res.Url,
              gameImg: game.ThumbnailUrl,
              gameName: game.GameNameEn
            }
            this.$store.commit('setShowGame', true)
            this.$store.commit('setGameInfo', gameInfo)
          } else {
            Toast(this.$t('lang.home.gameMaintenancePrompt'))
          }
        }).catch(() => {
          Toast(Toast(this.$t('lang.home.gameMaintenancePrompt')))
        })
      } else {
        this.$router.push('/Login')
      }
    },
    close () {
      this.showGame = false
    },
    onShowGiftPop () {
      if (localStorage.getItem('SevenDayGiftModel') && localStorage.getItem('SevenDayGiftModel') === 'versionC') {
        this.$router.push('/NewcomerSignIn')
      } else {
        let modals = store.state.modals
        modals[0].showing = true
        store.commit('setModals', modals)
        store.commit('setCurrentModalIndex', 0)
        store.commit('setGiftIconClicked', true)
      }
    },
    onShowSelfMadeGamesSubMenu () {
      let that = this
      if (!this.wheelList || (this.wheelList && this.wheelList.length === 0)) {
        let data = {}
        if (this.userInfo) {
          data = {UserId: this.userInfo.UserId}
        }
        request('post', '/innovation/luckywheel/get_wheel', data, false).then(res => {
          that.wheelList = res
          that.onShowLuckyWheelGamePop(this.wheelList[0])
        })
      } else {
        that.onShowLuckyWheelGamePop(this.wheelList[0])
      }
      // this.showSelfMadeGamesSubMenu = !this.showSelfMadeGamesSubMenu
    },
    closeLuckyWheelGamePop () {
      this.showLuckyWheelGamePop = false
      this.showSelfMadeGamesSubMenu = false
      setCurrentModal(99)
      // 弹窗队列
      // eslint-disable-next-line no-eval
      let popList = eval(localStorage.getItem('popList'))
      if (popList && popList.length > 0) {
        setTimeout(() => {
          let popNow = popList.shift()
          store.commit('setCurrentModalIndex', popNow)
          setCurrentModal(popNow)
          localStorage.setItem('popList', JSON.stringify(popList))
        }, 350)
      }
    },
    fetchDiscount () {
      if (localStorage.getItem('discountItem')) {
        this.discountList = JSON.parse(localStorage.getItem('discountItem')).discountList
      }
    },
    onShowLuckyWheelGamePop (item) {
      this.showSelfMadeGamesSubMenu = false
      this.showLuckyWheelGamePop = true
      this.theOwnWheel = item
    },
    onShowOneRupeeTreasureGamePop () {
      this.showSelfMadeGamesSubMenu = false
      this.$router.push('/Treasure')
    },
    closeLuckyCardGamePop () {
      this.showLuckyCardGamePop = false
      this.showSelfMadeGamesSubMenu = false
    },
    onShowLuckyCardGamePop () {
      this.showSelfMadeGamesSubMenu = false
      this.showLuckyCardGamePop = true
    },
    closeTimeLimitDeposit () {
      this.showLimitTimePop = false
      let modals = store.state.modals
      modals[8].showing = false
      store.commit('setModals', modals)
    },
    closeDiscount () {
      let modals = store.state.modals
      modals[6].showing = false
      store.commit('setModals', modals)
      // 弹窗队列
      // eslint-disable-next-line no-eval
      let popList = eval(localStorage.getItem('popList'))
      if (popList && popList.length > 0) {
        setTimeout(() => {
          let popNow = popList.shift()
          store.commit('setCurrentModalIndex', popNow)
          setCurrentModal(popNow)
          localStorage.setItem('popList', JSON.stringify(popList))
        }, 350)
      }
    },
    onShowLotteryPop () {
      this.showSelfMadeGamesSubMenu = false
      this.showLotteryPop = true
    },
    onShowBonusPop () { // 点击右下角晃动的gift图标时
      let modals = store.state.modals
      modals[1].showing = true
      store.commit('setModals', modals)
      store.commit('setCurrentModalIndex', 1)
      localStorage.setItem('clickFirstDepositIcon', '1')
    },
    onShowCallbackPop () {
      let modals = store.state.modals
      modals[2].showing = true
      store.commit('setModals', modals)
      store.commit('setCurrentModalIndex', 2)
      localStorage.setItem('clickCallBackIcon', '1')
    },
    closeDepositPop () {
      let modals = store.state.modals
      modals[1].showing = false
      store.commit('setModals', modals)
      if (localStorage.getItem('clickFirstDepositIcon') && localStorage.getItem('clickFirstDepositIcon') === '1') {
        localStorage.setItem('clickFirstDepositIcon', '0')
      } else {
        // 弹窗队列
        // eslint-disable-next-line no-eval
        let popList = eval(localStorage.getItem('popList'))
        if (popList && popList.length > 0) {
          setTimeout(() => {
            let popNow = popList.shift()
            store.commit('setCurrentModalIndex', popNow)
            setCurrentModal(popNow)
            localStorage.setItem('popList', JSON.stringify(popList))
          }, 350)
        } else {
          if (this.$route.name.toLocaleLowerCase() === 'home') {
            if (store.state.modals[15].popupTimes < store.state.modals[15].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 15)
              setCurrentModal(15)
            } else if (store.state.modals[3].popupTimes < store.state.modals[3].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 3)
              setCurrentModal(3)
            } else if (store.state.modals[5].popupTimes < store.state.modals[5].maxPopupTimes && store.state.shareFiestaShow) {
              store.commit('setCurrentModalIndex', 5) // 弹出推广狂欢
              setCurrentModal(5)
            } else if (store.state.modals[10].popupTimes < store.state.modals[10].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 10) // vip弹窗
              setCurrentModal(10)
            } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
              store.commit('setCurrentModalIndex', 11) // 站内信
              setCurrentModal(11)
            } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 13)
              setCurrentModal(13)
            }
          }
        }
      }
    },
    nextToDeposit () {
      this.showHomeGuide = false
      this.showDepositGuide = true
    },
    nextToWithdraw () {
      this.showDepositGuide = false
      this.showWithdrawGuide = true
    },
    nextToSupport () {
      this.showWithdrawGuide = false
      this.showSupportGuide = true
      this.$store.commit('setShowLeftMenu', true)
      setTimeout(() => {
        let supportMenu = document.getElementById('chat-support')
        supportMenu.scrollIntoView()
        this.supportTop = supportMenu.getBoundingClientRect().top - 3
      }, 300)
    },
    nextToGiftGuide () {
      this.$store.commit('setShowLeftMenu', false)
      this.showSupportGuide = false
    },
    setLimitTimeDepositTimer (timeLeft) {
      if (this.userInfo && timeLeft > 0) {
        this.showLimitTimeIcon = true
        if (!this.limitTimer) {
          this.limitTimer = setInterval(() => {
            timeLeft -= 1000
            if (timeLeft > 0) {
              this.timeLeftString = getTimeSpanString(timeLeft)
            } else {
              this.timeLeftString = '00:00:00'
              this.showLimitTimeIcon = false
              clearInterval(this.limitTimer)
            }
          }, 1000)
        }
      }
    },
    setDepositBonusTimer () {
      if (this.userInfo && this.userInfo.CreateTimeSpan > 0) {
        let nowTimeSpan = (new Date()).getTime()
        let timeLeft = 24 * 60 * 60 * 1000 - (nowTimeSpan - this.userInfo.CreateTimeSpan)
        let timer = setInterval(() => {
          timeLeft -= 1000
          if (timeLeft > 0) {
            this.timeLeftString = getTimeSpanString(timeLeft)
          } else {
            this.timeLeftString = '00:00:00'
            clearInterval(timer)
          }
        }, 1000)
      } else {
        let timeLeft = 24 * 60 * 60 * 1000
        let timer = setInterval(() => {
          timeLeft -= 1000
          if (timeLeft > 0) {
            this.timeLeftString = getTimeSpanString(timeLeft)
          } else {
            this.timeLeftString = '00:00:00'
            clearInterval(timer)
          }
        }, 1000)
      }
    },
    initActivity () {
      let data = {}
      let type = ''
      if (isIOS()) {
        type = 'ios'
      } else if (typeof window.Android === 'undefined' && !isIOS()) {
        type = 'android_h5'
      } else if (typeof window.Android !== 'undefined' && !isIOS()) {
        type = 'android_app'
      }
      if (this.userInfo && this.userInfo.UserId) {
        data = {UserId: this.userInfo.UserId, ShowType: type}
      } else {
        data = {UserId: null, ShowType: type}
      }
      const url = '/innovation/activity/data-init'
      request('post', url, data, true).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    callWheel () {
      if (this.$route.query.key && this.$route.query.key === 'wheelGame') {
        const path = this.$route.fullPath.replace('key=wheelGame', '') // 先获取路由路径
        this.$router.push(path) // 再跳转路由路径，query参数没带，被清除
        this.setCurrentRoute('')
        if (!this.wheelList || this.wheelList.length === 0) {
          let data = {}
          if (this.userInfo) {
            data = {UserId: this.userInfo.UserId}
          }
          request('post', '/innovation/luckywheel/get_wheel', data, false).then(res => {
            this.wheelList = res
            this.onShowLuckyWheelGamePop(this.wheelList[0])
          })
        } else {
          this.onShowLuckyWheelGamePop(this.wheelList[0])
        }
      }
    },
    getCashWeelReddot () {
      request('post', 'innovation/virality/get/collect/status', {userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).UserId : null, visitorCode: this.visitorCode}).then(res => {
        if (res) {
          this.cashWheelRedDot = res.IsHaveUncollect
        }
      })
    },
    fetchLocalAmount () {
      const url = '/innovation/home/get-system-settings'
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      const data = {IsApp: 1, CampaignId: cid}
      request('post', url, data, true).then(res => {
        if (res && res.SevenDaySettingAmount) {
          this.$store.commit('setSevenDaySettingAmount', res.SevenDaySettingAmount)
          localStorage.setItem('SevenDaySettingAmount', res.SevenDaySettingAmount)
        }
        this.$store.commit('setSharingStarIcon', res.InviteRankActivitySwitch)
        this.$store.commit('setInviteeObj',
          {
            sevenDayReward: res.SevenDayReward,
            inviteeMaxReward: res.DefaultCampaignIdFirstDepositMaxReward,
            InviteeReward: res.InviteeReward
          })
        if (res.InviteActivityIcon) {
          this.$store.commit('setShareFiestaShow', true)
          this.fetchTask()
        } else {
          this.$store.commit('setShareFiestaShow', false)
        }
        // 参与充值活动的新用户才显示跳转到DepositAndWin的banner
        this.startupPopupConfig.BannerList = res.HomeBanners.filter((banner) => {
          // 修复后的写法（兼容旧环境）
          const redirectPath = banner.RedirectPath ? banner.RedirectPath.toLowerCase() : ''
          // 或更严谨的判断：
          // const redirectPath = banner.RedirectPath?.toLowerCase?.() || '';

          // 条件1：如果 depositActivityIcon 为 false，过滤 /depositandwin
          if (!this.$store.state.depositActivityIcon && redirectPath === '/depositandwin') {
            return false
          }

          // 条件2：如果 newUserIsShowIcon 为 false，过滤 /newcomersignin
          if (!this.$store.state.newUserIsShowIcon && redirectPath === '/newcomersignin') {
            return false
          }

          return true
        })
        // if (this.$store.state.depositActivityIcon) {
        //   this.startupPopupConfig.BannerList = res.HomeBanners
        // } else {
        //   this.startupPopupConfig.BannerList = res.HomeBanners.filter((banner) => {
        //     return !banner.RedirectPath || banner.RedirectPath.toLowerCase() !== '/depositandwin'
        //   })
        // }
        // if (!this.$store.state.newUserIsShowIcon) {
        //   this.startupPopupConfig.BannerList = res.HomeBanners.filter((banner) => {
        //     return !banner.RedirectPath || banner.RedirectPath.toLowerCase() !== '/newcomersignin'
        //   })
        // }
        this.allLocaleBanners = this.startupPopupConfig.BannerList
        this.appIcons = res.AppIcons
        if (this.startupPopupConfig.BannerList && this.startupPopupConfig.BannerList.length > 0) {
          let locale = localStorage.getItem('locale') || 'EN'
          this.startupPopupConfig.BannerList = this.startupPopupConfig.BannerList.filter((item) => {
            if (item.InternationCode === locale) {
              return item
            }
          })
        }
        this.loadIcons()
      }).catch(err => {
        console.log(err)
      })
    },
    fetchTask () {
      const url = '/innovation/invite_task/get_data'
      let data = {}
      if (this.userInfo) {
        data = {
          userId: this.userInfo.UserId
        }
      } else {
        data = {
          userId: ''
        }
      }
      request('post', url, data).then(res => {
        if (res) {
          this.shareFiestaPointShow = res.InviteTaskHot
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 流水返利增加判断是否有未读消息
    fetchActivityNormalReward () {
      const userUniqueId = this.userInfo && this.userInfo.UserId
      if (!userUniqueId) {
        return
      }
      request('post', '/innovation/activity-normal/get-total-reward', {
        UserId: userUniqueId
      }).then(res => {
        if (res) {
          this.normalFlowRewardWaitClaim = res.TotalReceived < res.TotalRewards
        }
      })
    },
    // 查询输反活动待领取金额
    getCashbackWaitingClaim () {
      // 过滤hotBanners，查找是否含有输反
      this.hotBanners = this.allGames.filter((item) => {
        return item.Name === 'MostPopular'
      })[0].HotBanner
      if (this.hotBanners.length === 0) {
        return false
      }
      let cashback = this.hotBanners.filter((item) => {
        if (!item.RedirectPath) {
          return false
        }
        return item.RedirectPath.toLowerCase().indexOf('cashback') > -1
      })
      // 如果没有输反，直接返回
      if (cashback.length === 0) {
        return
      }
      let userUniqueId = this.userInfo && this.userInfo.UserId
      if (!userUniqueId) {
        return
      }
      request('post', '/innovation/cashback/awaiting/claim', {
        UserId: userUniqueId
      }).then(res => {
        if (res) {
          this.cashbackWaitClaim = res > 0
        }
      })
    },
    // 判断是否有小红点
    showRedCircle (routerName) {
      if (!routerName) {
        return false
      }
      if (routerName.indexOf('BetActivityRegularly') > -1) {
        return this.normalFlowRewardWaitClaim
      } else if (routerName.toLowerCase().indexOf('cashback') > -1) {
        return this.cashbackWaitClaim
      }
    },
    loadIcons () {
      if (this.appIcons && this.appIcons.length > 0) {
        let tempList = [
          {
            show: true,
            label: this.$t('lang.label.hot'),
            value: 'MostPopular'
          },
          {
            show: true,
            label: this.$t('lang.label.live'),
            value: 'LiveCasino'
          },
          {
            show: true,
            label: this.$t('lang.label.crash'),
            value: 'CrashGames'
          },
          {
            show: this.$store.state.internation !== 'VN',
            label: this.$t('lang.label.sports'),
            value: 'SportsGames'
          },
          {
            show: true,
            label: this.$t('lang.label.card'),
            value: 'Card'
          },
          {
            show: true,
            label: this.$t('lang.label.slots'),
            value: 'SlotGames'
          },
          {
            show: true,
            label: this.$t('lang.label.fishing'),
            value: 'FishingGames'
          },
          {
            show: true,
            label: this.$t('lang.label.lottery'),
            value: 'Lottery'
          }
        ]
        this.topList = []
        this.appIcons.forEach(icon => {
          let temp = tempList.find(t => t.value === icon.Name)
          if (temp) {
            temp.src = icon.Image
            temp.srcAct = icon.ImageActive
            this.topList.push(temp)
          }
        })
        this.showType = this.topList[0].value
        setTimeout(() => {
          this.initSwiper()
        }, 0)
      }
    },
    prev () {
      this.swiper.slidePrev()
    },
    next () {
      this.swiper.slideNext()
    },
    prev2 () {
      this.providerSwiper.slidePrev()
    },
    next2 () {
      this.providerSwiper.slideNext()
    },
    initSwiper () {
      if (!this.swiper) {
        const w = window.innerWidth * 0.075

        let that = this
        this.swiper = new Swiper('.swiper-container', {
          direction: 'horizontal', // 滑动方向，可设置水平(horizontal)或垂直(vertical)。
          loop: false, // 设置为true 则开启loop模式
          autoplay: false, // 自动切换时间
          slidesPerView: 6, // 设置slider容器能够同时显示的slides数量(carousel模式)。类型：number or auto
          centeredSlides: false, // 设定为true时，active slide会居中，而不是默认状态下的居左。
          spaceBetween: w, // 在slide之间设置距离（单位px）。
          initialSlide: that.levelIndex,
          loopAdditionaSlider: 1, // loop模式下会在slides前后复制若干个slide,，前后复制的个数不会大于原总个数。
          navigation: { // 左右按钮
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          on: {
            slideChange: function (e) {
              // that.showType = that.topList[that.levelIndex].value
              // that.selectType(that.showType)
            }
          }
        })
        that.levelIndex = this.swiper.activeIndex
      }
    },
    initProviderSwiper () {
      if (this.providerSwiper) {
        this.providerSwiper.destroy()
      }
      const w = window.innerWidth * 0.01
      this.providerSwiper = new Swiper('.provider-swiper-container', {
        direction: 'horizontal',
        loop: false,
        autoplay: false,
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: w, // 使用数值而不是vw单位
        initialSlide: this.providerIndex,
        allowTouchMove: true,
        navigation: {
          nextEl: '.provider-button-next',
          prevEl: '.provider-button-prev'
        },
        on: {
          slideChange: function (e) {
            // 可以在这里处理幻灯片改变的事件
          }
        },
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      })
      this.providerIndex = this.providerSwiper.activeIndex
    },
    setCallbackBonusTimer: function () {
      if (this.userInfo) {
        setInterval(() => {
          let nowTimeSpan = (new Date()).getTime()
          let timeLeft = (this.$store.state.callbackTimeSpan - nowTimeSpan)
          if (this.$store.state.callbackTimeSpan > 0) {
            this.timeLeftString = getTimeSpanString(timeLeft)
          } else {
            // clearInterval(timer)
          }
        }, 1000)
      }
    },
    setCallbackCashTimer: function () {
      if (this.userInfo) {
        setInterval(() => {
          let nowTimeSpan = (new Date()).getTime()
          let timeLeft = (this.$store.state.callbackCashTimeSpan - nowTimeSpan)
          if (this.$store.state.callbackCashTimeSpan > 0) {
            this.timeLeftString = getTimeSpanString(timeLeft)
          } else {
            // clearInterval(timer)
          }
        }, 1000)
      }
    },
    // 2022-03-06 CHP 加载启动弹窗的配置
    loadStartupPopup () {
      this.startupPopupConfig.BannerList = this.allLocaleBanners
      if (this.startupPopupConfig.BannerList && this.startupPopupConfig.BannerList.length > 0) {
        let locale = localStorage.getItem('locale') || 'EN'
        this.startupPopupConfig.BannerList = this.startupPopupConfig.BannerList.filter((item) => {
          if (item.InternationCode === locale) {
            return item
          }
        })
      }
    },
    bannerAction: function (type, path, param, iframeControlProperty, modalControlProperty) {
      if (path === '/cashWheel') {
        this.saveUserEvent('openFromBanner')
      }
      switch (type) {
        case 'GoToTournament':
          if (!this.userInfo) {
            this.$router.push('/Login')
          } else {
            let data = {
              GameCategory: param.GameCategroy,
              Internation: this.$store.state.internation,
              ActivityCode: param.ActivityCode
            }
            request('post', 'innovation/activity/verifyifactivityon', data, false).then(res => {
              if (res === false) {
                Toast(param.ActivityName + ' will start on Thursday 00:00:00 !')
              } else {
                this.$router.push({path: path})
                var activityItem = {
                  activityCode: param.ActivityCode,
                  category: param.GameCategroy,
                  activityImage: param.ActivityImage,
                  activityName: param.ActivityName,
                  bannerImage: param.BannerImage
                }
                sessionStorage.setItem('selectedActivity', JSON.stringify(activityItem))
                sessionStorage.setItem('SelectedActivityBanner', param.BannerImage)
                sessionStorage.setItem('comeFromTournament', '0') // 去往游戏类活动页时 selectedActivity
                this.selectActivity()
              }
            })
          }
          break
        case 'GoToRoute':
          if (path) {
            if (path.toLowerCase().indexOf('home') > -1) { // 跳转本页的游戏类型
              if (path.toLowerCase().indexOf('category=') > -1) {
                this.selectType(path.split('=')[1])
                return
              }
              if (param) {
                this.selectType(param)
              }
            } else {
              if (param) {
                this.$router.push({path: path, query: {param: param}})
              } else {
                this.$router.push({path: path})
              }
            }
          }
          break
        case 'PlayGame':
          this.fetchGame(JSON.parse(param))
          break
        case 'ShowIframe':
          if (this.userInfo) {
            if (path && path.toLowerCase().indexOf('jili') > -1) {
              this['showTournament'] = true // Banner中需要跳转到第三方页面的, 以iFrame形式显示
              this.iFrameSrc = iframeControlProperty
            } else {
              let end = ''
              if (iframeControlProperty.indexOf('pgebet.net') > -1) {
                if (localStorage.getItem('apkV') && localStorage.getItem('cid')) {
                  end = '?cid=' + localStorage.getItem('cid') + '&v=' + localStorage.getItem('apkV')
                } else if (localStorage.getItem('apkV') && !localStorage.getItem('cid')) {
                  end = '?v=' + localStorage.getItem('apkV')
                } else if (!localStorage.getItem('apkV') && localStorage.getItem('cid')) {
                  end = '?cid=' + localStorage.getItem('cid')
                }
              }
              window.open(iframeControlProperty + end)
            }
          } else {
            this.$router.push('/Login')
          }
          break
        case 'ShowModal':
          if (modalControlProperty && modalControlProperty === 'showLuckyWheelGamePop') {
            if (!this.wheelList || this.wheelList.length === 0) {
              let data = {}
              if (this.userInfo) {
                data = {UserId: this.userInfo.UserId}
              }
              request('post', '/innovation/luckywheel/get_wheel', data, false).then(res => {
                this.wheelList = res
                this.onShowLuckyWheelGamePop(this.wheelList[0])
              })
            } else {
              this.onShowLuckyWheelGamePop(this.wheelList[0])
            }
          } else {
            this[modalControlProperty] = true // 显示自研游戏（以组件弹出式对话框的形式）
          }
          break
      }

      clickEvent({EventNameEN: 'clickBanner', Param2: type})
    },
    handleCloseIFrame3Part (iframeControlProperty) {
      this[iframeControlProperty] = false
    },
    fetchWinners (num) {
      request2(
        'post',
        '/innovation/home/getrealtimewinners',
        {
          Number: num || 1,
          Culture: 'id'
          // Culture: localStorage.getItem('locale')
        }, true).then(res => {
        if (res) {
          this.winnerList = this.winnerList.concat(res.Winners)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    randomTimeout (index) {
      this.winnerTimeout = setTimeout(() => {
        if (this.$refs.winnerContent &&
          this.$refs.winnerContent !== undefined) {
          this.$refs.winnerContent.style.top = -32 * index + 'px'
        }
        this.fetchWinners(1)
        // this.fetchLiveUsersCount()
      }, Math.random() * 10000)
    },
    fetchLiveUsersCount () {
      request2(
        'post',
        '/innovation/home/getliveusercount',
        {
          internation: this.$store.state.internation
        }, true).then(res => {
        if (res) {
          this.livePlayersCount = res.livePlayersCount
        }
      }).catch(err => {
        console.log(err)
      })
    },
    fetchTimeLimitedBenefit () {
      if (this.userInfo) {
        const url = '/innovation/welfare-deposit/get-expiration-time'
        const data = {userId: this.userInfo.UserId}
        request('post', url, data, true).then(res => {
          if (res && res !== -1 && res.IsWelfareDepositPopUps) {
            this.timeLimitMaxAmount = res.WelfareMaxGift
            this.timeLimitRate = res.WelfareDiscount
            this.setLimitTimeDepositTimer(Math.floor(res.ExpirationTimeSpan))
          }
        })
      }
    },
    getTournaments () { // added by HHY 20220716
      clearInterval(this.waitingGamesInterval)
      this.waitingGamesInterval = null
      const url = 'innovation/activity/getgameactivitycategoryinfo'
      const data = {
        internation: this.$store.state.internation
      }
      request('post', url, data, true).then(res => {
        if (res !== undefined) {
          this.tournaments = res
          this.tournamentsCount = res.length
          if (res.length > 0) {
            if (res.length === 2) {
              res.reverse()
            }
            this.tournamentShown = res[0]
            sessionStorage.setItem('SelectedActivityBanner', this.tournamentShown.BannerImage)
          }
          if (this.comeFromTournament === '1') { // 由活动页而来 HHY 添加 2022-07-20
            var category = this.selectedActivity.category
            this.selectType(category) // 跳转到指定游戏类
          } else {
            const initCategory = this.$route.query.category
            this.selectType(initCategory || this.showType)
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getTournament (t) { // added by HHY 20220718
      const tnms = this.tournaments
      tnms.forEach(
        (item, index) => {
          if (item.GameCategroy === t) {
            // this.tournamentShown = item
            // sessionStorage.setItem('comeFromTournament', '0') // 若从游戏活动规则页面而来，则点击游戏类导航时，使其失效
            this.selectedCategory = item
            this.selectActivity()
          }
        }
      )
    },
    SelectSpecificType () {
      if (this.comeFromTournament === '1') { // 由活动页而来 HHY 添加 2022-07-20
        var category = this.selectedActivity.category
        this.selectType(category) // 跳转到指定游戏类
      }
    },
    GotoTournament (path, activityCode, category, activityImage, activityName, bannerImage) { // added by HHY 20220719
      if (!this.userInfo) {
        this.$router.push('/Login')
      } else {
        let data = {
          GameCategory: category,
          Internation: this.$store.state.internation,
          ActivityCode: activityCode
        }
        request('post', 'innovation/activity/verifyifactivityon', data, false).then(res => {
          if (res === false) {
            // Toast(this.$t('lang.home.gameActivityOnThursday'))
            Toast(activityName + ' will start on Thursday 00:00:00 !')
          } else {
            this.$router.push({path: path})
            sessionStorage.setItem('comeFromTournament', '0') // 去往游戏类活动页时

            var activityItem = {
              activityCode: activityCode,
              category: category,
              activityImage: activityImage,
              activityName: activityName,
              bannerImage: bannerImage
            }
            sessionStorage.setItem('SelectedActivityBanner', bannerImage)
            sessionStorage.setItem('selectedActivity', JSON.stringify(activityItem))
          }
        })
      }
    },
    verifyIfSelectedGameInActity (gamecode, gamecategory) { // 判断选定的游戏是否在明日要进行的游戏类活动中 HHY 2022-07-21
      const games = this.allGames[gamecategory]
      const keys = Object.keys(games)
      for (let k = 0; k < keys.length; k++) {
        const game = games[k]
        if (game.length === undefined || game.length === 0) {
          if (game.GameCode === gamecode) {
            return true
          }
        } else { // 有下级游戏
          const subkeys = Object.keys(game)
          for (let h = 0; h < subkeys.length; h++) {
            const subgame = game[h]
            if (subgame.GameCode === gamecode) {
              return true
            }
          }
        }
      }
      return false // 选定的游戏没有在游戏类活动中
    },
    selectActivity () {
      if (this.comeFromTournament === '1') { // 由游戏活动规则页跳转而来
        this.categoryShouldBeShown = this.selectedActivity.category
        this.activityCodeShouldBeShown = this.selectedActivity.activityCode
        this.activityImageShouldBeShown = this.selectedActivity.activityImage
        this.activityNameShouldBeShown = this.selectedActivity.activityName
        this.bannerImageShouldBeShown = this.selectedActivity.bannerImage
        return
      }
      this.categoryShouldBeShown = this.selectedCategory.GameCategroy
      this.activityCodeShouldBeShown = this.selectedCategory.ActivityCode
      this.activityImageShouldBeShown = this.selectedCategory.ActivityImage
      this.activityNameShouldBeShown = this.selectedCategory.ActivityName
      this.bannerImageShouldBeShown = this.selectedCategory.BannerImage
    },
    judgeGameFilter () {
      let index = 0
      this.isOnSearch = true
      if (this.gameList.length === 0) {
        this.isOnSearch = false
      }
      this.gameFilterList = this.gameList.filter(game => {
        index++
        if (index === this.gameList.length) {
          this.isOnSearch = false
        }
        return this.isGameInFiltered(game)
      })
    },
    isGameInFiltered (game) {
      if (!this.hasProviderTypes.includes(this.showType)) {
        return true
      }
      return game.GameNameEn.toLowerCase().includes(this.filteringGameText.toLowerCase())
    },
    onSearchInputFocused () {
      const gamePage = document.querySelector('#gamePage')
      gamePage.scrollTo(0, 152)
    },
    onSearchInputBlur () {
      const gamePage = document.querySelector('#gamePage')
      gamePage.scrollTo(0, 0)
    },
    /****
     * 记录用户玩过的游戏到本地 2022-09-24 HHY
     * 记录用户玩过的最新游戏到本地 2022-09-27 HHY
     * */
    recordPlayedGame (game) {
      let storage = localStorage.getItem('PlayHistory')
      let histories = JSON.parse(storage)
      if (histories === null) {
        histories = []
      }
      var playedGame = {
        GameCode: game.GameCode,
        GameCategory: this.showType,
        PlayTime: new Date()
      }

      const len = histories.length
      if (len > 0) {
        let found = histories.find(item => item.GameCode === playedGame.GameCode && item.GameCategory === playedGame.GameCategory)
        if (found) {
          found.PlayTime = new Date()
        } else {
          var indx = histories.findIndex(f => f.GameCategory === playedGame.GameCategory)
          if (indx >= 0) { // 只有找到同类的游戏时
            histories.splice(indx, 1) // 删除玩过的同类游戏，这样只记录用户最新玩过的游戏
          }
          histories.push(playedGame)
        }
      } else {
        histories.push(playedGame)
      }
      localStorage.setItem('PlayHistory', JSON.stringify(histories))
    },
    /****
     * 将玩过的游戏刷选、排序、前置 2022-09-24 HHY
     * */
    mergeHistoryGames () {
      let storage = localStorage.getItem('PlayHistory')
      let histories = JSON.parse(storage)
      if (histories !== null) {
        let filteredHistories = histories.filter(g => g.GameCategory === this.showType) // 从所玩游戏历史中以游戏类进行筛选
        let sortedHistories = filteredHistories.sort((a, b) => new Date(b.PlayTime) - new Date(a.PlayTime)) // 从所玩游戏历史中以游戏类进行排序
        let filteredGames = []
        let gameListCopy = this.gameList.concat() // 复制数组
        for (let j = 0; j < sortedHistories.length; j++) { // 从锦标赛活动数组中筛选出玩过的游戏
          const h = sortedHistories[j]
          const g = gameListCopy.find(g => g.GameCode === h.GameCode)
          if (g) {
            filteredGames.push(g)
            gameListCopy.splice(gameListCopy.findIndex(f => f.GameCode === h.GameCode), 1) // 从游戏列表中（来自数据库）删除玩过的游戏
          }
        }
        let merged = [...filteredGames, ...gameListCopy] // 合并数组
        this.gameList = merged
      }
    },
    confirmGotoPage () {
      this.$router.push('/Deposit')
    },
    goto (route) {
      if (route === 'cashWheel') {
        this.saveUserEvent('openFromRightBar')
      } else if (route === 'SportsBetting') {
        LogUtils.saveUserEvent('iplIconClick', this.userInfo ? this.userInfo.UserId : '')
      }
      this.$router.push('/' + route)
    }
  },
  beforeDestroy () {
    if (this.limitTimer) {
      clearInterval(this.limitTimer)
    }
    if (this.swiper) {
      this.swiper.destroy()
    }
    if (this.providerSwiper) {
      this.providerSwiper.destroy()
    }
    clearTimeout(this.winnerTimeout)
    clearInterval(this.winnerInterval)
  }
}
</script>

<style lang="less" scoped>
/deep/ .mint-swipe-indicator {
  bottom: 3.888vw;
  background: #4B4B4B;
  width: 4.444vw;
  height: 1.111vw;
  border-radius: 5.833vw;
  opacity: 1;
}

/deep/ .mint-swipe-indicators .is-active {
  background: #FFFFFF;
  width: 11.388vw;
  opacity: 1;
}

.banner-list-wrapper {
  width: 100vw;
  height: 38.85vw;
  overflow: hidden;
}

.banner-list-wrapper-android {
  margin-top: calc(11.111vw + 1px);
}

.banner-image {
  width: 100%;
  height: auto;
}

.live-wrapper {
  background: #000000;
  padding: 5px 0px 0px 10px;
  display: flex;

  .user-count-wrapper {
    padding: 2px 0px;
    width: 60px;
    line-height: 12px;
    background: #FF1B1B;
    color: #FFFFFF;
    text-align: center;
    font-size: 12px;
  }

  .user-count {
    line-height: 28px;
    font-size: 14px;
    color: #F6D9AA;
    width: 50px;
    text-align: center;
    border-right: 1px solid #F6D9AA;
    white-space: nowrap;
    overflow: hidden;
  }

  .winnerContainer {
    overflow: hidden;
    padding: 0 10px;
    height: 28px;
    position: relative;
    width: calc(100vw - 120px);

    .winnerContent {
      position: absolute;
      left: 0;
      top: 0;
      transition: top 0.5s;
      width: 100%;

      .winner {
        font-size: 12px;
        line-height: 32px;
        color: #fff;
        transform: scale(0.9);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;

        span {
          color: #F6D9AA;
        }
      }
    }
  }
}

.fixedWidth {
  position: relative;
  height: max-content;
}

.gamePage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: #161616;
  padding: 56px 0 70px 0;

  .streamer {
    position: relative;
    margin: 2.5vw 0 1vw 0;
    left: 2.1vw;
    width: 97.916vw;
    height: 18.889vw;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .redPoint {
      position: absolute;
      top: -0.5vw;
      right: 3vw;
      width: 2.222vw;
      height: 2.222vw;
      background: #FF0000;
      border-radius: 50%;
    }

    .dailyBonus {
      position: absolute;
      left: 0;
      top: 1vw;
      width: 100%;
      font-size: 5.555vw;
      font-style: italic;
      font-weight: 900;
      letter-spacing: 0.01em;
      text-align: center;
      padding-right: 1.05vw;
      color: #FFFFFF;
    }

    .countDownTimer {
      position: absolute;
      left: 31.5vw;
      bottom: 3.8vw;
      width: 33.5vw;
      height: 5vw;
      line-height: 5vw;
      text-transform: capitalize;
      color: #DADADA;
      font-size: 3.055vw;
      font-weight: 700;
      text-align: center;
    }
  }

  .selectContainer {
    margin: auto;
    background: #201F1F;
    display: flex;
    width: 91.113vw;
    height: 13.888vw;
    overflow: hidden;
    border-radius: 2.222vw;

    .swiperBox {
      position: relative;
      height: 13.888vw;
      display: flex;
      width: 91.113vw;
      margin: 0;

      .swiper-button-prev {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 5vw;
        height: 13.888vw;
        box-shadow: 1.5vw 0 0.5vw 0 rgba(32, 31, 31, 0.3);
        background: rgba(32, 31, 31, 0.8);

        img {
          margin-right: 1.5vw;
          height: 2.5vw;
        }
      }

      .swiper-button-next {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 5vw;
        height: 13.888vw;
        box-shadow: -1.5vw 0 0.5vw 0 rgba(32, 31, 31, 0.3);
        background: rgba(32, 31, 31, 0.8);

        img {
          margin-right: 1.5vw;
          height: 2.5vw;
        }
      }

      .swiper-button-prev::after {
        display: none;
      }

      .swiper-button-next::after {
        display: none;
      }

      .swiper-button-disabled {
        display: none;
      }

      .swiper-container {
        display: flex;
        width: 88.263vw;
        height: 13.888vw;
        margin: 0;
        justify-content: center;

        .swiper-wrapper {
          display: flex;
          width: 88.263vw;
          margin: auto;
          height: 13.888vw;
        }
      }

      .swiper-slide {
        margin: auto;
        height: 13.888vw;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        width: max-content !important;
      }

      .swiper-slide-active {
      }

      .img-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: space-between;
        width: max-content;
        height: max-content;

        .middle-box {
          margin: 0 auto;
          width: max-content !important;
          height: 5.277vw;
          overflow: hidden;

          img {
            width: auto;
            height: 100%;
          }
        }
      }

      .bottom-line {
        position: relative;
        margin: 1vw auto 0 auto;
        font-size: 2.777vw;
        font-weight: 500;
        text-align: center;
        letter-spacing: -0.03em;
        width: max-content;
        height: 4.4444vw;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #686868;
      }

      .bottom-line-act {
        position: relative;
        margin: 1vw auto 0 auto;
        font-size: 2.777vw;
        font-weight: 500;
        text-align: center;
        letter-spacing: -0.03em;
        width: max-content;
        height: 4.4444vw;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
      }

      .line {
        width: 100%;
        line-height: 2.5vw;
        text-align: center;
      }
    }
  }

  .provider-button-prev {
    position: absolute;
    top: 2.5vw;
    left: 0;
    bottom: 0;
    z-index: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 9vw;
    height: 7.5vw;
    background: #161616;
    box-shadow: 1.5vw 0 0.5vw 0 rgba(22, 22, 22, 0.3);

    img {
      margin-right: 1vw;
      height: 2.222vw;
    }
  }

  .provider-button-next {
    position: absolute;
    top: 2.5vw;
    right: 0;
    bottom: 0;
    z-index: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 13vw;
    height: 7.5vw;
    background: #161616;
    box-shadow: -1.5vw 0 0.5vw 0 rgba(22, 22, 22, 0.3);

    img {
      margin-left: 5vw;
      height: 2.222vw;
    }
  }

  .providerContainer {
    position: relative;
    background: #161616;
    display: flex;
    height: 7.5vw;

    .providerBox {
      position: relative;
      display: flex;
      width: 100vw;
      height: 7.5vw;

      .swiper-button-prev::after {
        display: none;
      }

      .swiper-button-next::after {
        display: none;
      }

      .swiper-button-disabled {
        display: none;
      }

      .provider-swiper-container {
        padding: 0;
        display: flex;
        height: 7.5vw;
        width: 90vw;
        margin: auto;
        justify-content: flex-start;

        .swiper-wrapper {
          display: flex;
          width: 90vw;
          margin: auto;
          height: 7.5vw;
        }
      }

      .swiper-slide {
        width: max-content;
        height: 7.5vw;
        margin: 0 1vw;

        .img-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-content: space-between;
          width: max-content;
          height: 7.5vw;

          img {
            margin: 0 3.8vw;
            width: auto;
            height: 3.986vw;
          }
        }

        .act {
          border: 0.3vw solid #F6D9AA;
          border-radius: 2.222vw;
        }
      }

      .swiper-slide-active {
        .img-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-content: space-between;
          width: max-content;
          overflow: visible;
          height: 7.5vw;
        }
      }
    }
  }

  .fixed {
    position: fixed;
    margin-left: 4.4435vw;
    width: 91.113vw;
    top: 96px;
    z-index: 4;
    border-radius: 0 0 2.222vw 2.222vw;
  }

  .fixedAndroid {
    top: 56px !important;
  }

  .gameContainer {
    position: relative;
    padding: 0 4.444vw;

    .gameFilter {
      display: flex;
      width: calc(100vw - 32px);
      height: 7.222vw;
      background-color: #161616;
      margin-top: 2.5vw;

      .searchRow {
        position: relative;
        height: 7.222vw;
        width: 92.222vw;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        border-radius: 0.833vw;

        img {
          margin-left: 1.94vw;
          width: 4.444vw;
        }

        input {
          width: 100%;
          height: 7.222vw;
          line-height: 7.222vw;
          font-size: 3.333vw;
          color: #686868;
          text-align: left;
          margin-left: 2.5vw;
        }
      }
    }

    .gameContent {
      position: relative;
      padding: 2.5vw 0 5.6vw 0;
      box-sizing: border-box;
      width: 91.113vw;
      display: flex;
      flex-wrap: wrap;

      .emptyGames {
        display: block;
        margin-top: 5px;
        width: 100vw;
        text-align: center;
        font-size: 14px;
      }

      .game {
        width: 43.5694vw;
        height: 34.3722vw;
        margin-bottom: 5.556vw;
        float: left;
        position: relative;

        .red-circle {
          position: absolute;
          right: -1vw;
          top: -1vw;
          width: 2.777vw;
          height: 2.777vw;
          border-radius: 50%;
          background-color: red;
          z-index: 3;
          overflow: visible;
        }

        .imgContainer {
          position: relative;
          overflow: hidden;
          border-radius: 6px;

          img {
            width: 100%;
            border-radius: 6px;
          }

          .game-image-wrapper {
            position: relative;
            width: 100%;
            height: 27.6638vw;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            z-index: 2;
          }

          .game-image-back {
            position: absolute;
            width: 100%;
            height: 27.6638vw;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 50%;
            z-index: 1;
          }

          .game-image {
            width: 100%;
            overflow: hidden;
          }

          .imgMask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 27.6638vw;
            z-index: 2;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 58.82%, #000000 120.45%);
          }
        }

        .new-game {
          position: absolute;
          top: 1.388vw;
          left: 1.388vw;
          width: 8.889vw;
          height: auto;
          z-index: 2;
        }

        p {
          width: 100%;
          font-weight: 500;
          font-size: 3.333vw;
          line-height: calc(3.333vw + 2px);
          color: #C4C4C4;
          margin-top: 2.778vw;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }
      }

      .game:nth-child(even) {
        margin-left: 3.888vw;
      }

      .last {
        margin-right: 0;
      }

      /deep/ .mint-loadmore-content {
        overflow-x: visible;

        &:after {
          content: "020";
          display: block;
          height: 0;
          clear: both;
          visibility: hidden;
        }

        .mint-loadmore-bottom {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          height: 20px;
          line-height: 20px;
          margin-bottom: -20px;
        }
      }
    }
  }

  .holi {
    overflow: hidden;
    margin-left: -7.5px;
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      height: 66px;
    }
  }

  .shareFiesta {
    position: relative;
    margin-left: -4px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 4px;
    margin-top: 2px;
    overflow: visible;

    .red-circle-shareFiesta {
      top: -4px;
      right: 15.6px;
    }

    img {
      height: 70px;
    }
  }
  .doubleDay{
    position: relative;
    overflow: hidden;
    margin-right: 1px;
    width: 60px;
    height: 45px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0px;
    .rewardNum{
      position: absolute;
      color: #A86500;
      font-size: 1.527vw;
      font-weight: 700;
      width: 50px;
      bottom: 0;
      text-align: center;
    }
    img {
      width: 70px;
      height: auto;
    }
  }
  .diwaliFestival {
    position: relative;
    left: -2px;
    overflow: hidden;
    margin-left: 0;
    height: 44.8px;
    width: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 6px;

    img {
      width: 50px;
      height: 44.8px;
    }

    .redPoint {
      position: absolute;
      top: 12px;
      right: 2.5px;
    }
  }

  .sharingStar {
    overflow: hidden;
    margin-left: 0;
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: -4px;
    margin-right: 3px;

    img {
      width: 52px;
    }
  }

  .ipl {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    margin-right: 5px;
    width: 48.5px;
    overflow: hidden;

    .iplNum{
      position: absolute;
      bottom: 3px;
      color: #A86500;
      font-size: 6.5px;
      font-weight: 700;
      width: 50px;
      text-align: center;
    }

    img {
      width: 100%;
      height: auto;
    }
  }
  .cashWheelIndexIcon{
    overflow: hidden;
    margin-left: -7px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    width: 13.788vw;
    height: 9.883vw;
    margin-left: 0vw;
    position: relative;
    .redPoint{
      position: absolute;
      top: 0.4vw;
      right: 2vw;
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background: radial-gradient(74.31% 74.31% at 31.38% 30.73%, #F9273A 0%, #982F39 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      z-index: 3;;
      overflow: visible;
    }
    img {
      width: 13.788vw;
      height: 10.883vw;
    }
  }
  .depositWin {
    overflow: hidden;
    margin-left: -7px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;

    img {
      height: 44.8px;
    }
  }

  .gift-icon-wrapper {
    position: relative;
    margin: 3px auto;

    .red-circle-position {
      top: 1px;
      right: 6px;
    }

    .gift-icon {
      height: 45px;
      display: block;
    }
  }

  .gift-icon-timeLimit {
    position: fixed;
    top: calc(42vw + 135px + 10vw);
    left: 3px;
    z-index: 4;
    width: 1px;

    .limit-bk {
      display: flex;
      width: 60px;
      height: 60px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;

      .limit-timer {
        position: relative;
        left: 0px;
        top: 39px;
        width: 100%;
        height: max-content;
        color: #000000;
        font-size: 8px;
        font-weight: 900;
        line-height: 11px;
        text-align: center;
      }
    }
  }

  .sportsBetting {
    overflow: hidden;
    width: 58px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 58px;
    }
  }

  .self-made-games-menu {
    width: 52px;
    height: 37px;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 3px auto 7px auto;

    span {
      color: black;
      font-size: 20px;
      letter-spacing: -3px;
      position: absolute;
      bottom: 50px;
      right: 95px;
    }
  }

  .self-made-game-icons {
    display: flex;
    position: fixed;
    bottom: 266px;
    right: 30px;
    height: 43px;
    background: rgba(0, 0, 0, 0.6);
    border: solid 1px #F5EAB1;
    border-right: none;
    border-radius: 8px 0 0 8px;
    padding: 10px 8px 6px;
    z-index: 2;

    .luckyWheelMenu_wheel {
      width: 36px;
      height: 36px;
      margin-right: 12px;
      margin-top: -7px;
    }

    .luckyWheelMenu_card {
      width: 36px;
      height: 36px;
      margin-right: 32px;
      margin-top: -7px;
    }
  }

  .bonus-icon-wrapper {
    margin: 0 0 0 0;
    position: relative;
    margin-bottom: -2px;

    .bonus-icon {
      width: 52px;
      height: auto;
    }

    .countdown {
      position: absolute;
      bottom: 7px;
      left: 50%;
      transform: translate(-50%);
      text-align: center;
      width: 100%;
      color: #A86500;
      font-size: 6.5px;
      font-weight: 700;
    }
  }

  .user-guide-home {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: rgba(0, 0, 0, .6);
    padding: 0;
    box-sizing: border-box;

    .guide-region {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 10px 10px;
      margin: 56px 0 20px 0;
      position: relative;

      .guide-image {
        width: 100%;
      }

      .selectItem {
        text-align: center;
        flex: 1;

        img {
          height: 30px;
        }

        div {
          font-size: 12px;
          margin-top: 4px;
          width: 100%;
          min-width: max-content;
        }

        .labelAct {
          font-size: 14px;
          color: #F6D9AA;
        }
      }

      .guide-region-border {
        position: absolute;
        border: 3px solid #F6D9AA;
        top: 5px;
        width: calc(100vw - 20px);
        height: 65px;
        border-radius: 6px;
      }
    }

    .prompt-region {
      width: calc(100vw - 20px - 20px);
      position: relative;
      padding: 28px 0px 0px 0px;

      .prompt-box {
        background: rgba(104, 104, 104, .78);
        padding: 20px 20px;
        margin: 0px 10px 0px 44px;
        border-radius: 6px;
        width: calc(100vw - 10px - 20px - 30px);
        color: #F6D9AA;
        font-size: 16px;
        line-height: 25px;
      }

      .logo {
        z-index: 3;
        position: absolute;
        top: 0;
        left: 10px;
      }

      .prompt-text {
        color: #F6D9AA;
      }
    }

    .next-button-wrapper {
      margin-top: 20px;
      text-align: right;
      padding: 0 20px;

      .next-button {
        background: linear-gradient(180deg, #FFF2D5 0%, #FFDC8C 21.35%, #8B6801 72.92%);
        border-radius: 6px;

        padding: 5px 20px;
        font-size: 24px;
        font-weight: bold;
        color: #473800;
      }
    }
  }

  .user-guide-deposit, .user-guide-withdraw {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: rgba(0, 0, 0, .6);
    padding: 0;
    box-sizing: border-box;

    .guide-region-border {
      border: 3px solid #F6D9AA;
      width: 98%;
      left: 1%;
      position: fixed;
      bottom: 10px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      z-index: 102;
      height: 60px;
      border-radius: 6px;
    }

    .guide-region {
      position: fixed;
      bottom: 0;
      width: 100%;
      height: 70px;
      display: flex;
      justify-content: space-around;
      padding-top: 6px;
      text-align: center;

      .guide-image {
        width: 100%;
      }

      .guideItem {
        flex: 1;

        .label {
          font-size: 12px;
          color: #686868;
        }

        .labelAct {
          color: #F6D9AA;
        }
      }
    }

    .prompt-region {
      width: calc(100vw - 20px);
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .prompt-box {
        background: rgba(104, 104, 104, .78);
        padding: 20px 20px;
        margin: 0px 10px 0px 30px;
        border-radius: 6px;
        width: calc(100vw - 20px - 30px);
        color: #F6D9AA;
        font-size: 16px;
        line-height: 25px;
      }

      .logo {
        z-index: 3;
        position: relative;
        top: 20px;
        left: 0px;
      }

      .prompt-text {
        color: #F6D9AA;
      }

      .next-button-wrapper {
        margin-top: 20px;
        text-align: right;

        .next-button {
          background: linear-gradient(180deg, #FFF2D5 0%, #FFDC8C 21.35%, #8B6801 72.92%);
          border-radius: 6px;

          padding: 5px 20px;
          font-size: 24px;
          font-weight: bold;
          color: #473800;
        }
      }
    }
  }

  .user-guide-support {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 101;
    background-color: rgba(0, 0, 0, .6);
    padding: 0;
    box-sizing: border-box;

    .guide-region {
      position: absolute;
      border: 3px #F6D9AA solid;
      border-radius: 6px;
      margin: 0 28px;
      padding: 0 7px;
      height: 35px;

      .guide-image {
        width: 100%;
      }

      .menuItem {
        display: flex;
        align-items: center;

        img {
          margin-right: 18px;
        }

        div {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
        }
      }
    }

    .prompt-region {
      width: calc(100vw - 20px);

      .prompt-box {
        background: rgba(104, 104, 104, .78);
        padding: 20px 20px;
        margin: 0px 10px 0px 30px;
        border-radius: 6px;
        width: calc(100vw - 20px - 30px);
        color: #F6D9AA;
        font-size: 16px;
        line-height: 25px;
      }

      .logo {
        z-index: 3;
        position: relative;
        top: 20px;
        left: 0px;
      }

      .prompt-text {
        color: #F6D9AA;
      }

      .next-button-wrapper {
        margin-top: 20px;
        text-align: right;

        .next-button {
          background: linear-gradient(180deg, #FFF2D5 0%, #FFDC8C 21.35%, #8B6801 72.92%);
          border-radius: 6px;

          padding: 5px 20px;
          font-size: 24px;
          font-weight: bold;
          color: #473800;
        }
      }
    }
  }

  .user-guide-gift {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: rgba(0, 0, 0, .6);
    padding: 0;
    box-sizing: border-box;

    .guide-region-border {
      border: 3px solid #F6D9AA;
      width: 98%;
      left: 1%;
      position: fixed;
      bottom: 10px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      z-index: 102;
      height: 60px;
      border-radius: 6px;
    }

    .guide-region {

      .bonus-icon-wrapper {
        border: 3px solid #F6D9AA;
        position: absolute;
        bottom: 72px;
        right: 2px;
        /* z-index: 3; */
        box-sizing: border-box;

        .bonus-icon {
          width: 40px;
          display: block;
          margin: 0 auto;
        }
      }
    }

    .prompt-region {
      width: calc(100vw - 20px);
      position: relative;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);

      .prompt-box {
        background: rgba(104, 104, 104, .78);
        padding: 20px 20px;
        margin: 0px 10px 0px 30px;
        border-radius: 6px;
        width: calc(100vw - 20px - 30px);
        color: #F6D9AA;
        font-size: 16px;
        line-height: 25px;
      }

      .logo {
        z-index: 3;
        position: relative;
        top: 20px;
        left: 0px;
      }

      .prompt-text {
        color: #F6D9AA;
      }

      .next-button-wrapper {
        margin-top: 20px;
        text-align: right;

        .next-button {
          background: linear-gradient(180deg, #FFF2D5 0%, #FFDC8C 21.35%, #8B6801 72.92%);
          border-radius: 6px;

          padding: 5px 20px;
          font-size: 24px;
          font-weight: bold;
          color: #473800;
        }
      }
    }
  }

  .user-guide-bonus-deposit {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: rgba(0, 0, 0, .6);
    padding: 0;
    box-sizing: border-box;

    .guide-region {
      width: 100%;
      padding: 170px 20px 0px 20px;
      text-align: center;

      .guide-image {
        width: 100%;
      }

      .deposit-gift-image {
        width: 100%;
        padding: 10px;
        border: 3px solid #F6D9AA;
        border-radius: 6px;
      }
    }

    .prompt-region {
      width: calc(100vw - 20px);
      position: absolute;
      bottom: 20px;

      .prompt-box {
        background: rgba(104, 104, 104, .78);
        padding: 20px 20px;
        margin: 0px 10px 0px 34px;
        border-radius: 6px;
        width: calc(100vw - 20px - 30px);
        color: #F6D9AA;
        font-size: 16px;
        line-height: 25px;
      }

      .logo {
        z-index: 3;
        position: absolute;
        top: -10px;
        left: 0px;
      }

      .prompt-text {
        color: #F6D9AA;
      }
    }

    .next-button-wrapper {
      margin-top: 20px;
      text-align: right;

      .next-button {
        background: linear-gradient(180deg, #FFF2D5 0%, #FFDC8C 21.35%, #8B6801 72.92%);
        border-radius: 6px;

        padding: 5px 20px;
        font-size: 24px;
        font-weight: bold;
        color: #473800;
      }
    }
  }
}

.gamePage::-webkit-scrollbar {
  display: none
}

.fixedWidth::-webkit-scrollbar {
  display: none
}

.right-bar {
  position: fixed;
  right: 5px;
  bottom: 95px;
  width: 55px;
  overflow: visible;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  justify-content: center;
  z-index: 4;

  .red-circle {
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background: radial-gradient(74.31% 74.31% at 31.38% 30.73%, #F9273A 0%, #982F39 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    z-index: 3;;
    overflow: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue